import classNames from 'clsx';
import React, { useCallback, useState } from 'react';

import type { Menu } from '@swf/cms';

import useLightHeader from '../../hooks/useLightHeader';
import CMSMenuGraphProvider from '../CMSMenu/CMSMenuGraphProvider';

import styles from './CMSNavigation.scss';
import CMSNavigationItem from './CMSNavigationItem';
import CMSNavigationSubmenu from './CMSNavigationSubmenu';

interface Props {
  menu: Menu;
  maxDepth: number;
  className?: string;
}

const CMSNavigation: React.FC<Props> = ({ menu, maxDepth, className }) => {
  const [open, setOpen] = useState(false);
  const [openIndex, setOpenIndex] = useState<number>();
  const { children: submenu } = menu;
  const lightHeader = useLightHeader();

  const openSubmenu = useCallback((index: number) => {
    setOpen(true);
    setOpenIndex(index);
  }, []);

  const closeSubmenu = useCallback(() => {
    setOpen(false);
  }, []);

  return !lightHeader && submenu.length ? (
    <nav className={classNames(styles.nav, className)}>
      <CMSMenuGraphProvider menu={menu}>
        <ul className={styles.navList} onMouseLeave={() => closeSubmenu()}>
          {submenu.map((item, index) => (
            <React.Fragment key={item.uid}>
              <li
                className={styles.topLevel}
                onTouchEnd={() => openSubmenu(index)}
                onMouseOver={() => openSubmenu(index)}
              >
                <CMSNavigationItem reference={item} maxDepth={maxDepth} />
              </li>
              <li className={styles.subNav}>
                {open && openIndex === index && maxDepth > 1 && (
                  <CMSNavigationSubmenu menuItemRef={item} onSelect={closeSubmenu} />
                )}
              </li>
            </React.Fragment>
          ))}
        </ul>
      </CMSMenuGraphProvider>
    </nav>
  ) : null;
};

export default CMSNavigation;
